export const translations = {
  fr: {
    nav: { home: "Accueil", vehicles: "Nos véhicules", offers: "Nos offres", reviews: "Avis", contact: "Contact", book: "Réserver" },
    pages: {
      fleetLabel: "Notre flotte",
      vehiclesTitle: "Nos véhicules",
      vehiclesSub: "Une flotte d'exception, du confort Business à l'électrique premium. Choisissez et réservez en quelques secondes.",
      offersTitle: "Nos offres",
      offersSub: "Transferts aéroport à prix fixe et prestations sur mesure pour chaque occasion.",
      reviewsTitle: "Avis clients",
      reviewsSub: "La confiance de nos clients, notre plus belle récompense.",
      contactTitle: "Contact",
      contactSub: "À votre service, jour et nuit, partout en Belgique.",
      bookCta: "Réserver maintenant",
      passengers: "passagers",
    },
    hero: {
      overline: "Chauffeur privé VIP · Belgique",
      line1: "L'art du",
      line2: "trajet",
      line3: "d'exception.",
      sub: "EBEN EZER TAXI VIP — une prise en charge discrète, ponctuelle et raffinée. Réservation immédiate ou programmée, partout en Belgique.",
      cta: "Réserver ma course",
      cta2: "Nos services",
    },
    marquee: "DISCRET · ÉLÉGANT · PONCTUEL · CHAUFFEUR VIP · CONFIDENTIEL · PREMIUM ·",
    airport: {
      overline: "Transferts aéroport",
      title: "Prix fixe, zéro surprise",
      sub: "Tarif garanti à l'avance vers Brussels Airport (Zaventem) et Brussels South (Charleroi). Suivi de vol, accueil et bagages inclus.",
      from: "au départ de",
      book: "Réserver ce trajet",
      oneway: "aller simple · dès",
      allin: "TVAC · chauffeur VIP",
    },
    services: {
      overline: "Nos prestations",
      title: "Une expérience taillée sur mesure",
      sub: "Chaque détail pensé pour votre confort et votre tranquillité.",
      items: [
        { title: "Taxi VIP", desc: "Véhicules haut de gamme, intérieur cuir, eau et discrétion absolue. Le luxe à l'état pur pour chaque déplacement." },
        { title: "Réservation immédiate ou programmée", desc: "Besoin d'un chauffeur maintenant ou dans trois semaines ? Réservez en quelques secondes, à l'heure qui vous convient." },
        { title: "Prise en charge professionnelle", desc: "Chauffeurs formés, ponctuels et courtois. Accueil personnalisé, aide aux bagages et itinéraire optimisé." },
      ],
    },
    how: {
      overline: "Simple & fluide",
      title: "Comment ça marche",
      steps: [
        { n: "01", t: "Réservez", d: "Indiquez départ, arrivée, date et heure. Le prix estimé s'affiche instantanément." },
        { n: "02", t: "Payez l'acompte", d: "Confirmez avec un acompte sécurisé de 20% via Stripe. Le solde se règle à bord." },
        { n: "03", t: "Voyagez", d: "Votre chauffeur VIP arrive à l'heure. Détendez-vous, nous nous occupons du reste." },
      ],
    },
    reviews: {
      overline: "Ils nous font confiance",
      title: "La parole à nos clients",
      items: [
        { q: "Ponctualité irréprochable et véhicule impeccable. Le chauffeur était d'un professionnalisme rare. Je ne prends plus que ce service.", n: "Sophie L.", r: "Bruxelles" },
        { q: "Réservation ultra simple, prix transparent affiché avant de payer. Aucune surprise. Un vrai service premium.", n: "Marc D.", r: "Anvers" },
        { q: "Pris en charge à l'aéroport avec une élégance folle. Discrétion et confort au rendez-vous. Bravo.", n: "Amélie V.", r: "Liège" },
      ],
    },
    booking: {
      overline: "Réservation",
      title: "Réservez votre course VIP",
      sub: "Estimation instantanée. Acompte sécurisé de 20%.",
      pickup: "Adresse de départ",
      dropoff: "Adresse d'arrivée",
      pickupPh: "Ex: Grand-Place, Bruxelles",
      dropoffPh: "Ex: Aéroport de Zaventem",
      date: "Date",
      time: "Heure",
      passengers: "Passagers",
      estimate: "Calculer le prix estimé",
      estimating: "Calcul en cours…",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      notes: "Note (optionnel)",
      notesPh: "Numéro de vol, bagages, siège enfant…",
      distance: "Distance",
      duration: "Durée estimée",
      total: "Prix estimé",
      deposit: "Acompte à payer (20%)",
      rest: "Solde à bord",
      pay: "Payer l'acompte et confirmer",
      paying: "Redirection vers le paiement…",
      edit: "Modifier le trajet",
      errFields: "Veuillez remplir le départ et l'arrivée.",
      errContact: "Veuillez remplir nom, email et téléphone.",
      errQuote: "Impossible de calculer le prix. Vérifiez les adresses.",
    },
    contact: {
      overline: "Contact",
      title: "À votre service, jour et nuit",
      sub: "Une question, une demande particulière ? Notre équipe vous répond.",
      call: "Appelez-nous",
      write: "Écrivez-nous",
      area: "Zone de service",
      areaVal: "Toute la Belgique",
    },
    footer: {
      tagline: "L'excellence du transport privé en Belgique.",
      legal: "Mentions légales",
      terms: "Conditions générales",
      privacy: "Confidentialité",
      cancel: "Politique d'annulation",
      rights: "Tous droits réservés.",
      cancelPolicy: "Remboursement intégral avant acceptation du chauffeur · 50% si annulation plus de 2h avant le départ · acompte conservé en dessous de 2h.",
    },
    config: {
      fleetLabel: "LUXURY FLEET",
      title: "Choisissez votre véhicule idéal",
      subtitle: "Sélectionnez le véhicule qui correspond le mieux à votre trajet, vos passagers et vos attentes de confort.",
      select: "Sélectionner",
      selected: "Sélectionné",
      pax: "passagers",
      lug: "bagages",
      comfort: "Confort",
      vehicles: [
        { id: "business", name: "Business Class", model: "Mercedes E-Class", year: 2025, power: "Hybride", tier: "Premium", desc: "Idéal pour les transferts aéroport et rendez-vous d'affaires.", badge: "Le plus populaire", features: ["Sièges cuir", "Climatisation", "Wi-Fi gratuit", "Recharge USB", "Trajet silencieux"] },
        { id: "vip", name: "VIP Class", model: "Mercedes S-Class", year: 2025, power: "Hybride", tier: "VIP", desc: "Transport de luxe pour dirigeants et clients VIP.", badge: "Luxe", features: ["Intérieur cuir exécutif", "Climatisation arrière", "Eau premium", "Prestations de luxe", "Confort maximal"] },
        { id: "van", name: "Van Class", model: "Mercedes V-Class", year: 2025, power: "Diesel", tier: "Premium", desc: "Parfait pour familles, groupes et équipes.", badge: "Groupes", features: ["Cabine spacieuse", "Ports USB", "Climatisation", "Wi-Fi", "Portes coulissantes"] },
        { id: "actyon", name: "KGM Actyon Platinum", model: "KGM Actyon Platinum 2026", year: 2026, power: "Hybride", tier: "Premium", desc: "SUV hybride raffiné, confort et sobriété pour vos trajets d'affaires.", badge: "Nouveauté", features: ["SUV hybride", "Sièges cuir", "Climatisation", "Wi-Fi", "Grand coffre"] },
        { id: "modely", name: "Tesla Model Y", model: "Tesla Model Y 2026", year: 2026, power: "Électrique", tier: "Premium", desc: "SUV 100% électrique, silencieux et écologique, sans compromis sur le luxe.", badge: "Électrique", features: ["100% électrique", "Toit panoramique", "Climatisation", "Wi-Fi", "Zéro émission"] },
        { id: "model3", name: "Tesla Model 3", model: "Tesla Model 3 2026", year: 2026, power: "Électrique", tier: "Premium", desc: "Berline électrique élégante et performante, idéale en ville.", badge: "Électrique", features: ["100% électrique", "Intérieur épuré", "Climatisation", "Recharge USB", "Zéro émission"] },
      ],
      steps: { service: "Choisissez le service", passengers: "Passagers & bagages", pickup: "Adresse de départ", destination: "Destination", date: "Date", time: "Heure" },
      services: ["Transfert aéroport", "Rendez-vous d'affaires", "Réservation à l'heure", "Chauffeur privé", "Événement spécial", "Mariage", "Transfert hôtel"],
      adults: "Adultes", children: "Enfants", luggageLarge: "Grands bagages", luggageCabin: "Bagages cabine",
      pickupPh: "Saisissez l'adresse de départ", destPh: "Saisissez la destination", current: "Ma position actuelle",
      contactTitle: "Vos coordonnées", name: "Nom complet", email: "Email", phone: "Téléphone",
      summaryTitle: "Récapitulatif", sVehicle: "Véhicule", sPax: "Passagers", sPickup: "Départ", sDest: "Destination", sDistance: "Distance", sDuration: "Durée", sFare: "Prix estimé", sDeposit: "Acompte (20%)", sRemaining: "Solde au chauffeur",
      book: "RÉSERVER MA COURSE", booking: "Redirection…",
      done: "Terminé",
      fillRoute: "Renseignez le départ et la destination pour afficher le prix.",
      errContact: "Complétez le trajet, la date/heure et vos coordonnées.",
    },
  },
  nl: {
    nav: { home: "Home", vehicles: "Onze voertuigen", offers: "Ons aanbod", reviews: "Reviews", contact: "Contact", book: "Reserveren" },
    pages: {
      fleetLabel: "Onze vloot",
      vehiclesTitle: "Onze voertuigen",
      vehiclesSub: "Een uitzonderlijke vloot, van Business-comfort tot premium elektrisch. Kies en reserveer in enkele seconden.",
      offersTitle: "Ons aanbod",
      offersSub: "Luchthaventransfers aan vaste prijs en diensten op maat voor elke gelegenheid.",
      reviewsTitle: "Klantenreviews",
      reviewsSub: "Het vertrouwen van onze klanten, onze mooiste beloning.",
      contactTitle: "Contact",
      contactSub: "Tot uw dienst, dag en nacht, overal in België.",
      bookCta: "Nu reserveren",
      passengers: "passagiers",
    },
    hero: {
      overline: "Privéchauffeur VIP · België",
      line1: "De kunst van",
      line2: "de perfecte",
      line3: "rit.",
      sub: "EBEN EZER TAXI VIP — een discrete, stipte en verfijnde service. Onmiddellijk of gepland reserveren, overal in België.",
      cta: "Rit reserveren",
      cta2: "Onze diensten",
    },
    marquee: "DISCREET · ELEGANT · STIPT · VIP-CHAUFFEUR · VERTROUWELIJK · PREMIUM ·",
    airport: {
      overline: "Luchthaventransfers",
      title: "Vaste prijs, geen verrassingen",
      sub: "Vooraf gegarandeerd tarief naar Brussels Airport (Zaventem) en Brussels South (Charleroi). Vluchtopvolging, onthaal en bagage inbegrepen.",
      from: "vanuit",
      book: "Dit traject reserveren",
      oneway: "enkele reis · vanaf",
      allin: "incl. btw · VIP-chauffeur",
    },
    services: {
      overline: "Onze diensten",
      title: "Een ervaring op maat",
      sub: "Elk detail bedacht voor uw comfort en rust.",
      items: [
        { title: "VIP Taxi", desc: "Topvoertuigen, lederen interieur, water en absolute discretie. Pure luxe voor elke verplaatsing." },
        { title: "Onmiddellijk of gepland reserveren", desc: "Nu een chauffeur nodig of over drie weken? Reserveer in enkele seconden, op het uur dat u past." },
        { title: "Professionele begeleiding", desc: "Opgeleide, stipte en hoffelijke chauffeurs. Persoonlijk onthaal, bagagehulp en optimale route." },
      ],
    },
    how: {
      overline: "Eenvoudig & vlot",
      title: "Hoe het werkt",
      steps: [
        { n: "01", t: "Reserveer", d: "Geef vertrek, bestemming, datum en tijd op. De geschatte prijs verschijnt meteen." },
        { n: "02", t: "Betaal voorschot", d: "Bevestig met een beveiligd voorschot van 20% via Stripe. Het saldo betaalt u aan boord." },
        { n: "03", t: "Reis", d: "Uw VIP-chauffeur komt op tijd. Ontspan, wij regelen de rest." },
      ],
    },
    reviews: {
      overline: "Ze vertrouwen ons",
      title: "Onze klanten aan het woord",
      items: [
        { q: "Onberispelijke stiptheid en een smetteloos voertuig. De chauffeur was uiterst professioneel. Ik gebruik enkel nog deze service.", n: "Sophie L.", r: "Brussel" },
        { q: "Uiterst eenvoudige reservering, transparante prijs vooraf. Geen verrassingen. Een echte premiumservice.", n: "Marc D.", r: "Antwerpen" },
        { q: "Met veel elegantie opgehaald aan de luchthaven. Discretie en comfort verzekerd. Bravo.", n: "Amélie V.", r: "Luik" },
      ],
    },
    booking: {
      overline: "Reservering",
      title: "Reserveer uw VIP-rit",
      sub: "Directe schatting. Beveiligd voorschot van 20%.",
      pickup: "Vertrekadres",
      dropoff: "Aankomstadres",
      pickupPh: "Bv: Grote Markt, Brussel",
      dropoffPh: "Bv: Luchthaven Zaventem",
      date: "Datum",
      time: "Tijd",
      passengers: "Passagiers",
      estimate: "Bereken geschatte prijs",
      estimating: "Berekenen…",
      name: "Volledige naam",
      email: "E-mail",
      phone: "Telefoon",
      notes: "Notitie (optioneel)",
      notesPh: "Vluchtnummer, bagage, kinderzitje…",
      distance: "Afstand",
      duration: "Geschatte duur",
      total: "Geschatte prijs",
      deposit: "Te betalen voorschot (20%)",
      rest: "Saldo aan boord",
      pay: "Voorschot betalen en bevestigen",
      paying: "Doorverwijzen naar betaling…",
      edit: "Traject wijzigen",
      errFields: "Vul vertrek en aankomst in.",
      errContact: "Vul naam, e-mail en telefoon in.",
      errQuote: "Kan de prijs niet berekenen. Controleer de adressen.",
    },
    contact: {
      overline: "Contact",
      title: "Tot uw dienst, dag en nacht",
      sub: "Een vraag of speciale wens? Ons team helpt u graag.",
      call: "Bel ons",
      write: "Mail ons",
      area: "Servicegebied",
      areaVal: "Heel België",
    },
    footer: {
      tagline: "De excellentie van privévervoer in België.",
      legal: "Wettelijke vermeldingen",
      terms: "Algemene voorwaarden",
      privacy: "Privacy",
      cancel: "Annuleringsbeleid",
      rights: "Alle rechten voorbehouden.",
      cancelPolicy: "Volledige terugbetaling vóór aanvaarding door de chauffeur · 50% bij annulering meer dan 2u vóór vertrek · voorschot behouden onder 2u.",
    },
    config: {
      fleetLabel: "LUXURY FLEET",
      title: "Kies uw ideale voertuig",
      subtitle: "Selecteer het voertuig dat het best past bij uw rit, passagiers en comfortverwachtingen.",
      select: "Selecteren",
      selected: "Geselecteerd",
      pax: "passagiers",
      lug: "bagage",
      comfort: "Comfort",
      vehicles: [
        { id: "business", name: "Business Class", model: "Mercedes E-Class", year: 2025, power: "Hybride", tier: "Premium", desc: "Ideaal voor luchthaventransfers en zakelijke afspraken.", badge: "Populairst", features: ["Lederen zetels", "Klimaatregeling", "Gratis wifi", "USB-lader", "Stille rit"] },
        { id: "vip", name: "VIP Class", model: "Mercedes S-Class", year: 2025, power: "Hybride", tier: "VIP", desc: "Luxevervoer voor directie en VIP-klanten.", badge: "Luxe", features: ["Executive lederen interieur", "Klimaatregeling achter", "Premium water", "Luxe voorzieningen", "Maximaal comfort"] },
        { id: "van", name: "Van Class", model: "Mercedes V-Class", year: 2025, power: "Diesel", tier: "Premium", desc: "Perfect voor gezinnen, groepen en teams.", badge: "Groepen", features: ["Ruime cabine", "USB-poorten", "Airconditioning", "Wifi", "Schuifdeuren"] },
        { id: "actyon", name: "KGM Actyon Platinum", model: "KGM Actyon Platinum 2026", year: 2026, power: "Hybride", tier: "Premium", desc: "Verfijnde hybride SUV, comfort en zuinigheid voor uw zakelijke ritten.", badge: "Nieuw", features: ["Hybride SUV", "Lederen zetels", "Airco", "Wifi", "Grote koffer"] },
        { id: "modely", name: "Tesla Model Y", model: "Tesla Model Y 2026", year: 2026, power: "Elektrisch", tier: "Premium", desc: "100% elektrische SUV, stil en ecologisch, zonder in te boeten op luxe.", badge: "Elektrisch", features: ["100% elektrisch", "Panoramadak", "Airco", "Wifi", "Nul uitstoot"] },
        { id: "model3", name: "Tesla Model 3", model: "Tesla Model 3 2026", year: 2026, power: "Elektrisch", tier: "Premium", desc: "Elegante en krachtige elektrische sedan, ideaal in de stad.", badge: "Elektrisch", features: ["100% elektrisch", "Strak interieur", "Airco", "USB-lader", "Nul uitstoot"] },
      ],
      steps: { service: "Kies de dienst", passengers: "Passagiers & bagage", pickup: "Vertrekadres", destination: "Bestemming", date: "Datum", time: "Tijd" },
      services: ["Luchthaventransfer", "Zakelijke afspraak", "Uurboeking", "Privéchauffeur", "Speciaal evenement", "Huwelijk", "Hoteltransfer"],
      adults: "Volwassenen", children: "Kinderen", luggageLarge: "Grote bagage", luggageCabin: "Handbagage",
      pickupPh: "Voer het vertrekadres in", destPh: "Voer de bestemming in", current: "Mijn huidige locatie",
      contactTitle: "Uw gegevens", name: "Volledige naam", email: "E-mail", phone: "Telefoon",
      summaryTitle: "Overzicht", sVehicle: "Voertuig", sPax: "Passagiers", sPickup: "Vertrek", sDest: "Bestemming", sDistance: "Afstand", sDuration: "Duur", sFare: "Geschatte prijs", sDeposit: "Voorschot (20%)", sRemaining: "Saldo aan chauffeur",
      book: "RESERVEER MIJN RIT", booking: "Doorverwijzen…",
      done: "Klaar",
      fillRoute: "Vul vertrek en bestemming in om de prijs te zien.",
      errContact: "Vul het traject, datum/tijd en uw gegevens in.",
    },
  },
};
